import { NavMenuItem, navMenuItemFromResponse } from './NavMenuItem';
import { SettingsV2 } from './SettingsV2/SettingsV2';

export interface Settings {
  settingsV1: Record<string, string>;
  settingsV2?: SettingsV2;
  storeSettings: Record<string, string>;
  availableLocales: string[];
  menu: NavMenuItem[];
  footer1: NavMenuItem[];
  footer2: NavMenuItem[];
}

export const settingsFromResponse = (responseData: any): Settings => {
  let settingsV2: SettingsV2 | undefined;
  try {
    settingsV2 = JSON.parse(responseData.settings?.style_overrides ?? '{}');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Failed to parse settings_v2', e);
  }

  return {
    settingsV1: responseData.settings,
    settingsV2,
    storeSettings: responseData.store_settings,
    availableLocales: responseData.available_locales ?? [],
    menu: (responseData.menu ?? []).map(navMenuItemFromResponse),
    footer1: (responseData.footer1 ?? []).map(navMenuItemFromResponse),
    footer2: (responseData.footer2 ?? []).map(navMenuItemFromResponse),
  };
};
